// pricing.js
// Centralises all pricing calculation logic.
// Shipping and tax are placeholder implementations – replace with real rates.

// ── Shipping ────────────────────────────────────────────────────────────────
// Simple tiered shipping: free above $100, flat $7.99 otherwise.
// Replace with a real carrier API (EasyPost, ShipEngine, etc.) for production.
export function calculateShipping(subtotal) {
  if (subtotal >= 100) return 0;       // Free shipping
  if (subtotal >= 50) return 4.99;     // Reduced shipping
  return 7.99;                          // Standard shipping
}

// Human-readable shipping label for display
export function shippingLabel(subtotal) {
  if (subtotal >= 100) return "FREE";
  return `$${calculateShipping(subtotal).toFixed(2)}`;
}

// ── Tax ─────────────────────────────────────────────────────────────────────
// Flat 8% sales tax placeholder.
// Replace with a real tax API (TaxJar, Avalara, etc.) for production.
const TAX_RATE = 0.08;

export function calculateTax(subtotal) {
  return parseFloat((subtotal * TAX_RATE).toFixed(2));
}

// ── Order Total ──────────────────────────────────────────────────────────────
export function calculateTotal(subtotal) {
  const shipping = calculateShipping(subtotal);
  const tax = calculateTax(subtotal);
  return parseFloat((subtotal + shipping + tax).toFixed(2));
}

// ── Currency formatter ───────────────────────────────────────────────────────
export function formatCurrency(amount) {
  return `$${Number(amount).toFixed(2)}`;
}

// Approved price list (for reference / validation)
export const APPROVED_PRICES = [
  5, 10, 25, 29, 39, 49, 50, 59, 69, 99, 100, 119, 125, 129, 147, 150,
  167, 187, 197, 199, 200, 247, 249, 297, 299, 300, 325,
];
